import './FooterStyle.less';

import classNames from 'classnames';
import * as React from 'react';

interface IFooterProps {
  centerAlign?: boolean;
  showPhoto?: boolean;
}

export default class Footer extends React.PureComponent<IFooterProps> {
  public static defaultProps: Partial<IFooterProps> = {
    centerAlign: true,
  };

  private currentYear = new Date().getFullYear();

  public render() {
    const { showPhoto, centerAlign } = this.props;
    return (
      <div className={classNames('od-footer', { 'photo-footer': showPhoto })}>
        <div className="row middle-xs center-xs">
          <div
            className={classNames('trademark col-fill', 'footer-text-container', {
              'text-center': centerAlign,
            })}
          >
            <div className="text-product-medium footer-container">
              <span>
                &copy; {this.currentYear}
                &nbsp;&nbsp;Opendoor&nbsp;&nbsp;
              </span>
              <span>
                <a href="/terms">Terms of service</a>
                {' · '}
                <a href="/privacy">Privacy policy</a>
                {' · '}
                <a href="/privacyrequest">Do not sell my info</a>{' '}
              </span>
            </div>
          </div>
          <div className="col-fill">
            <img
              src="https://images.opendoor.com/source/s3/imgdrop-production/3c3b55d2bafb409fa42c8b33fd43c9d2.png?service=consumer"
              alt="Equal housing opportunity"
              height={45}
            />
          </div>
        </div>
      </div>
    );
  }
}
